import { useDispatch, useSelector } from "react-redux";
import { assigned_userActions } from "../../actions";
import { CONTENT_GROUP_PARTICIPANTS, userConstants } from "../../constants";
import { useEffect, useState } from "react";
import { reset } from "redux-form";
import { useDetectOutsideClick } from "../../utils/useDetectOutsideClick";

/**
 * Hook to manage assigned user popup functionality
 * @param {Object} props - Component props
 * @param {string} props.content_group_id - Content group identifier
 * @param {string} props.workspace_id - Workspace identifier
 * @param {Object} props.popupRef - Reference to popup element
 */
function useAssignedUserPopupHook({ content_group_id, workspace_id, popupRef }) {
    const dispatch = useDispatch();
    
    // Selectors
    const { isOpenParticipantModal } = useSelector(state => state.participant_popup);
    const userUnCheckValue = useSelector(state => state.assigned_user.unchecked_value);
    
    // State
    const [uncheckValue, setUnCheckValue] = useState([]);
    const [isActive, setIsActive] = useDetectOutsideClick(popupRef, false);

    /**
     * Handles form submission for assigned users
     * @param {Object} values - Form values containing assigned users
     */
    const onSubmit = (values) => {
        // Transform assigned users data
        const checkValue = values.assigned_users.map(data => ({
            user_id: data,
            _destroy: false
        }));
        const all_user_ids = checkValue.map(data => data.user_id);
        const updated_user = uncheckValue.filter(u => !all_user_ids.includes(u.user_id));
        const result = [...updated_user, ...checkValue];

        const onSuccess = (response) => {
            dispatch({ type: userConstants.ASSIGNED_USER_REQUEST, payload: response });
            dispatch(reset('assignedUserForm'));
            dispatch({
                type: userConstants.UPDATE_CONTENTGROUP,
                payload: response
            });
            dispatch({ type: userConstants.UNCHECKED_VALUE, payload: '' });
            closeDropDownPopup();
        };

        const params = {
            reqparams: { assigned_users: result },
            workspace_id,
            content_group_id,
            onSuccess,
            onError: () => {} // Empty error handler
        };

        dispatch(assigned_userActions.createAssignedUserForPopup(params));
    };

    const closeDropDownPopup = () => {
        dispatch({ type: CONTENT_GROUP_PARTICIPANTS.CLOSE_PARTICIPANTS_MODAL });
    };

    // Update unchecked values when userUnCheckValue changes
    useEffect(() => {
        if (userUnCheckValue) {
            const new_array = uncheckValue.filter(
                u => u.user_id !== userUnCheckValue.user_id
            );
            setUnCheckValue([...new_array, userUnCheckValue]);
        }
    }, [userUnCheckValue]);

    // Handle popup open state
    useEffect(() => {
        if (isOpenParticipantModal) {
            setIsActive(true);
        }
    }, [isOpenParticipantModal]);

    // Handle outside click to close popup
    useEffect(() => {
        if (!isActive) {
            closeDropDownPopup();
        }
    }, [isActive]);

    return {
        onSubmit,
        closeDropDownPopup
    };
}

export default useAssignedUserPopupHook;